:host {
  display: block;
  padding: 2rem;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.theme-section,
.status-section {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.theme-section > div {
  width: 100%;
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.color-section {
  min-width: 300px;
  flex: 1;
}

.color-grid {
  display: grid;
  gap: 1rem;
  margin-top: 1rem;
}

.color-box {
  padding: 1rem;
  border-radius: var(--border-radius);
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: var(--font-family);
  font-size: 0.875rem;
  box-shadow: var(--elevation-01);
}